import * as React from "react";

const BellIconSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="M12.5 26.788v-1.5h1.808v-7.461q0-2.017 1.245-3.567a5.52 5.52 0 0 1 3.197-1.983v-1.873h2.5v1.873a5.52 5.52 0 0 1 3.197 1.983q1.245 1.55 1.245 3.567v7.462H27.5v1.5zm7.498 2.808q-.746 0-1.276-.53a1.74 1.74 0 0 1-.53-1.278h3.616q0 .75-.532 1.278-.531.53-1.278.53"
        ></path>
    </svg>
);

export default BellIconSVG;
